import React, { useEffect, useContext, useState } from 'react';
import * as routes from '../constants/routes';
import SessionContext from './SessionContext';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap'
import Loading from './Loading';
import MixpanelContext from 'react-mixpanel';

function LandingPage({ history }) {
  const sessionContext = useContext(SessionContext);
  const mixpanel = useContext(MixpanelContext)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!sessionContext.isLoading) {
      if (sessionContext.isAuthenticated && sessionContext.household) {
        history.push(routes.SCHEDULES);
      } else if (sessionContext.isAuthenticated) {
        history.push(routes.ONBOARDING)
      } else {
        setLoading(false)
        mixpanel.track('WFH_Login_Opened')
      }
    }
  }, [sessionContext.isLoading])

  const handleSSOClick = () => {
    mixpanel.track('WFH_Google_SSO_Opened')
    sessionContext.loginWithRedirect()
  }

  return (
    <>
      <div className="fixed-background" />
      <Container className="landing">
        <Row style={{paddingLeft: '5%', paddingRight: '5%', height: '100%'}}>
          <Col xs={12} style={{  marginTop: 'auto', marginBottom: 'auto'}}>
            <Row>
              <Col className="leftCol" xs={12} md={5}>
                <h2>WFH Scheduler</h2>
                <p style={{fontSize: 13}}>Find calm in the chaos when you’re working from home with Work from Home Scheduler, a household resource management app for booking workspaces and scheduling responsibilities so you can be productive with everyone under one roof. </p>
              </Col>
              <Col className="rightCol" style={{minHeight: 300 }} xs={12} md={7}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', height: '100%'}}>
                  <img className="brandLogo" src="https://nest.owllabs.com/assets/img/logo-black.svg" alt="WFH Scheduler" />
                  { loading && <Loading style={{marginTop: 25}} /> }
                  { !loading && <>
                    <h3 style={{marginTop: 5}}>Sign into your household</h3>
                    <button className="btn btn-primary" onClick={handleSSOClick} style={{marginTop: 15}}>
                      Sign in or create account
                    </button>
                  </>}
                  <div style={{flexGrow: 1, minHeight: 50}} />
                  <div style={{fontSize: 12, marginRight: -35, marginLeft: -35}}>
                    Work from Home Scheduler was built with love by Owl Labs, creators of the Meeting Owl. Learn more about our mission to make location irrelevant on <a href="https://www.owllabs.com/future-of-work" target="_blank">our website</a>.
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default withRouter(LandingPage);
